<div class="skeleton-preloader-list-container">
  <div *ngFor="let entity of entities" class="skeleton-section-item">
    <skeleton-preloader-tile-component></skeleton-preloader-tile-component>
  </div>
</div>
